import { Link } from "react-router";
import { useTaxonomy } from "@/lib/taxonomy";

// Scope chips for the dashboard. Plain links so the filter survives a reload
// and stays shareable; the category filter is preserved across a change.
export function ScopeFilter({
  month,
  category,
  active,
}: {
  month: string;
  category?: string;
  active?: string;
}) {
  const { activeScopes } = useTaxonomy();

  const href = (scope?: string) => {
    const params = new URLSearchParams({ month });
    if (category) params.set("category", category);
    if (scope) params.set("scope", scope);
    return `/?${params.toString()}`;
  };

  const chip = (isActive: boolean) =>
    `shrink-0 whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm font-medium transition-colors ${
      isActive
        ? "bg-primary text-primary-foreground shadow-sm"
        : "bg-card text-muted-foreground ring-1 ring-black/[0.05] active:bg-muted"
    }`;

  return (
    <div className="-mx-4 flex gap-2 overflow-x-auto px-4 [scrollbar-width:none] lg:mx-0 lg:px-0 [&::-webkit-scrollbar]:hidden">
      <Link to={href()} className={chip(!active)}>
        All scopes
      </Link>
      {activeScopes.map((s) => (
        <Link key={s.key} to={href(s.key)} className={chip(active === s.key)}>
          {s.label}
        </Link>
      ))}
    </div>
  );
}
